import { render } from "./PageGaussianChannelStrategy.vue?vue&type=template&id=c52369fa"
import script from "./PageGaussianChannelStrategy.vue?vue&type=script&lang=js"
export * from "./PageGaussianChannelStrategy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__